<template>
  <div>
    <nav class="sc-esjQYD iuKTVe">
      <section class="sc-kfGgVZ hAmwjd">
        <a class="sc-kPVwWT eKvwgK" @click="handleTo('/')">
          <img src="@/assets/images/logo1.png" class="sc-hwwEjo gHwJGh">
        </a>
        <a class="text-logo" @click="handleTo('/')">
          <span>Koio deal</span>
        </a>
      </section>
      <div class="sc-eXEjpC jJbeFf">
        <a :class="['sc-iQKALj', newNav === '/' ? 'logpht' : 'gwxwxK']" @click="handleTo('/')">
          <div class="sc-kIPQKe ehyTOY icon-home"></div>
          <div class="sc-ibxdXY dCCQFH">Dashboard</div>
        </a>
        <a :class="['sc-iQKALj', newNav === '/order' ? 'logpht' : 'gwxwxK']" @click="handleTo('/order')">
          <div class="sc-kIPQKe ehyTOY icon-dollar-sign"></div>
          <div class="sc-ibxdXY dCCQFH">Order</div>
        </a>
        <!-- <a :class="['sc-iQKALj', newNav === '/rebates' ? 'logpht' : 'gwxwxK']" @click="handleTo('/rebates')">
          <div class="sc-kIPQKe ehyTOY icon-dollar-sign"></div>
          <div class="sc-ibxdXY dCCQFH">Rebates</div>
        </a>
        <a :class="['sc-iQKALj notifications', newNav === '/notifications' ? 'logpht' : 'gwxwxK']"
          @click="handleTo('/notifications')">
          <div class="sc-kIPQKe ehyTOY icon-notifications">
            <div class="sc-gzOgki bkbKmk">2</div>
          </div>
          <div class="sc-ibxdXY dCCQFH">Notifications</div>
        </a>
        <a :class="['sc-iQKALj', newNav === '/contacts' ? 'logpht' : 'gwxwxK']" @click="handleTo('/contacts')">
          <div class="sc-kIPQKe ehyTOY icon-user"></div>
          <div class="sc-ibxdXY dCCQFH">Contacts</div>
        </a> -->
        <a :class="['sc-iQKALj', newNav.includes('/settings') ? 'logpht' : 'gwxwxK']"
          @click="handleTo('/settings/account')">
          <div class="sc-kIPQKe ehyTOY icon-settings"></div>
          <div class="sc-ibxdXY dCCQFH">Settings/Account</div>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "LeftNavigation",
  props: ['navlist'],
  data() {
    return {
      urls: 'https://app.snagshout.com',

      newNav: '',

      activeSubMenu: 0, // 默认选中活动管理子项
      subMenuItems: [

      ],
    };
  },
  methods: {
    handleTo(url) {
      this.$router.push(url);
    },
    selectSubMenu(item) {
      this.activeSubMenu = item.route;
      this.$emit("subMenuChange", item);

      // 路由跳转
      if (item.route) {
        this.$router.push(item.route);
      }
    },
    initRouter() {
      this.activeSubMenu = this.$route.meta.fatherRoute2;
      console.log(this.activeSubMenu);

    }
  },
  mounted() {
    // 根据当前路由设置激活状态
    this.subMenuItems = this.navlist;
    this.initRouter();
  },
  watch: {
    $route: {
      handler() {
        this.newNav = this.$route.path;
        this.initRouter();
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style lang="scss" scoped>
.iuKTVe {
  box-shadow: rgb(0, 0, 0) 0px 0px 15px 0px;
  background-color: black;
  display: flex;
  flex-direction: column;
  width: 110px;
  height: 100vh;
  transition: width 0.5s ease;
  overflow: hidden;
  position: fixed;

  .hAmwjd {
    background: rgb(0, 0, 0);
    display: flex;
    overflow: hidden;
    padding: 30px 0px 40px;
    max-width: 100%;
    z-index: 2;

    .eKvwgK {
      background-color: #FFF;
      color: rgb(102, 102, 102);
      display: flex;
      font-size: 18px;
      height: 45px;
      padding: 0px 33px;
      text-decoration: none;
      // width: 45px;
      z-index: 1;

      .gHwJGh {
        height: 45px;
        width: 66px;
      }
    }

    .text-logo {
      -webkit-box-align: center;
      align-items: center;
      display: flex;
      padding-right: 15px;
      margin-left: 20px;

      span {
        word-break: break-all;
        min-width: 100px;
        color: #FFF;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }

  .jJbeFf {
    max-width: 100%;
    overflow: hidden;
    z-index: 1;

    .logpht {
      color: rgb(255, 255, 255);
      cursor: pointer;
      display: flex;
      flex-direction: row;
      height: 26px;
      -webkit-box-pack: start;
      justify-content: start;
      padding-bottom: 30px;
      padding-top: 30px;
      position: relative;
      text-align: center;
      text-decoration: none;
      width: 100%;
    }

    .ehyTOY {
      -webkit-box-align: center;
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 21px;
      padding: 0px 45px;
      position: relative;
      text-decoration: none;
    }

    .dCCQFH {
      font-size: 16px;
      color: #FFF;
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      -webkit-box-pack: center;
      justify-content: center;
    }

    .gwxwxK {
      color: rgb(102, 102, 102);
      cursor: pointer;
      display: flex;
      flex-direction: row;
      height: 26px;
      -webkit-box-pack: start;
      justify-content: start;
      padding-bottom: 30px;
      padding-top: 30px;
      position: relative;
      text-align: center;
      text-decoration: none;
      width: 100%;
    }

    .fDQNyG {
      color: rgb(102, 102, 102);
      cursor: pointer;
      display: flex;
      flex-direction: row;
      height: 26px;
      -webkit-box-pack: start;
      justify-content: start;
      padding-bottom: 30px;
      padding-top: 30px;
      position: relative;
      text-align: center;
      text-decoration: none;
      width: 100%;
    }
  }
}

.iuKTVe:hover {
  width: 260px;
}

.bkbKmk {
  background: rgb(255, 0, 0);
  border-radius: 25px;
  bottom: -7px;
  color: white;
  font-family: effra, sans-serif;
  font-size: 12px;
  margin-left: 15px;
  padding: 2px 4px;
  position: absolute;
  right: auto;
  text-align: center;
}
</style>
